import $http from '$http';
import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';
export default {
    methods: {

        // 获取单条
        GetById(OrderId) {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                OrderId: OrderId
            };
            this.loading = true;
            $http.get("api/NetWorkCheck/GetByOrderId", params).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                this.loading = false;
                util.doResult(this, res, () => {

                    //console.log(util.filterAndSetData(this.OrderData, Data))

                    this.OrderData = Data
                    this.SchoolInfo = this.OrderData.SchoolInfo
                    this.NetInfo = this.OrderData.NetInfo
                    this.SalesInfo = this.OrderData.SalesInfo

                    // 拼接TabsTypes数组
                    this.TabsTypes = []
                    let $obj = this.OrderData.ClassInfo
                    let len = $obj.length
                    for (let i = 0; i < len; i++) {
                        this.TabsTypes.push({
                            index: i, //$obj[i].ClassInfo.ClassId
                            name: $obj[i].ClassInfo.ClassNick + '-' + $obj[i].CheckStatusName
                        })
                    }
                    this.TabId = 0 //默认选中第一个
                    this.ClassInfo = cloneDeep(this.OrderData.ClassInfo[0].ClassInfo)
                    this.FollowInfo = cloneDeep(this.OrderData.ClassInfo[0].FollowInfo)
                });
            });
        },

    }
}


// WEBPACK FOOTER //
// ./src/pages/Order/orderViewList/OrderQ2Page/networkDialog/services.js